<template>
    <div class="hj_popup"
         v-show="showPanel">
        <transition name="scale">
            <div class="centerPanel">
                <template v-if="is_cj">
                    <div class="con1">
                        <div class="title flex jb ac">
                            <p>采集到</p>
                            <img src="./img/icon_img21.png"
                                 @click="close_cj"
                                 class="close" />
                        </div>
                        <div class="my_hj_list">
                            <div class="my_hj_item flex ac"
                                 :class="item.active?'active':''"
                                 v-for="(item,index) in my_hj_list"
                                 @click="choose_hj(item)"
                                 :key="index">
                                <img src="./img/icon_img18.png"
                                     alt=" " />
                                <p>{{item.name}}</p>
                            </div>
                        </div>
                        <div class="btn flex jb ac">
                            <div class="flex jc ac"
                                 @click="create_hj">
                                <img src="./img/icon_img21.png"
                                     alt=" " />
                                <span>新建画夹</span>
                            </div>
                            <div class="flex jc ac active"
                                 @click="move">
                                <span>移动到此</span>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="is_edit">
                    <div class="con">
                        <div class="full">
                            <div class="alert_title flex jb ac">
                                <p>{{form.id==0?'新建画夹':'编辑画夹'}}</p>
                                <img src="./img/icon_img21.png"
                                     @click="close"
                                     class="close" />
                            </div>
                            <div class="alert_info flex jb">
                                <!-- <div class="thumb  ac flex">
                                    <el-upload :http-request="$projectUpload" class="avatar-uploader"
                                               :action="fileApi+'/api/front/upload/?storage=ali_oss'"
                                               :show-file-list="false"
                                               :on-success="handleAvatarSuccess"
                                               :before-upload="beforeAvatarUpload"
                                               accept=".jpg,.png,.jpeg">
                                        <div class="upload_area flex ac jc"
                                             v-if="!form.logo_url">
                                            <img src="./img/icon_img22.png"
                                                 class="upload_icon" />
                                            <p> 推荐尺寸：600x466px </p>
                                            <span>修改封面</span>
                                        </div>
                                        <div class="thumb_area "
                                             v-else>
                                            <img :src="form.logo_url" />
                                            <span>修改封面</span>
                                        </div>
                                    </el-upload>

                                </div> -->
                                <div class="input_area ">
                                    <div class="item">
                                        <p class="input_title">画夹标题 </p>
                                        <div class="input">
                                            <input type="text"
                                                   maxlength="10"
                                                   v-model="form.name"
                                                   class="input_text"
                                                   placeholder="请输入标题（必填）">
                                            <span class="count">{{form.name.length}} / 10</span>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <p class="input_title">画夹描述</p>
                                        <div class="input">
                                            <textarea class="input_text"
                                                      v-model="form.desc"
                                                      placeholder="简单描述下你的作品~"></textarea>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <button class="submit"
                                                v-loading="saveLoading"
                                                @click="handle_submit"
                                                :class="form.name.length<=0?'gary':''">确定</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </transition>
    </div>
</template>

<script>
// let IS_CJ = false //创建一个变量，当采集时，值为true，且不再修改
export default {
    data () {
        return {
            g_is_cj:false, // 外部传的参数
            is_cj: false,//是否是采集
            is_edit: true,//从画夹页面打开时，值为true,如果是采集的时候打开，值为false
            my_hj_list: [],
            showPanel: false,
            hj_popup_title: '',
            form: {
                id: 0,
                name: '',
                logo_url: '',
                desc: ''
            },
            saveLoading: false,
            fileApi: FILE_API_SERVER,
            current_draw: {}
        }
    },
    created () {
        this.g_is_cj = false
        this.get_hj_list()
    },
    computed: {

    },
    methods: {
        show (cate, is_cj) {
            if (is_cj == 1) {
                this.g_is_cj = true
                //如果cate传递过来的值为1，则为采集
                this.is_cj = true
                this.is_edit = false
                this.current_draw = cate
            } else if (cate) {
                this.g_is_cj = false
                this.is_cj = false
                this.is_edit = true
                this.form = { ...cate }
            }
            this.showPanel = true
            this.get_hj_list()
        },
        close () {
            if (this.g_is_cj) {
                //如果是采集弹窗打开的新建画夹弹窗，关闭新建画夹弹窗时，应该要显示采集弹窗
                this.is_cj = true
                this.is_edit = false
            } else {
                // 关闭
                this.showPanel = false
                this.$emit('close', false)
            }

        },
        //关闭采集
        close_cj () {
            // 关闭
            this.my_hj_list.forEach(e => {
                e.active = false
            })
            this.showPanel = false
            this.$emit('close', this.current_draw)
        },
        //上传头像
        handleAvatarSuccess (response, uploadFile) {
            this.form.logo_url = response.data.file_full_url
            // this.form.logo_url = URL.createObjectURL(uploadFile.raw)

        },
        beforeAvatarUpload (rawFile) {
            if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png') {
                this.$message({
                    type: 'warning',
                    message: "请上传jpg或者png格式的图片",
                })
                return false
            } else if (rawFile.size / 1024 / 1024 > 2) {
                this.$message({
                    type: 'warning',
                    message: "请上传2M以内的图片",
                })
                return false
            }
            return true
        },
        handle_submit () {
            // if (!this.form.logo_url) {
            //     this.$message.error('请上传画夹封面')
            //     return
            // }
            if (this.form.name.length <= 0) {
                this.$message.error('画夹标题不能为空')
                return
            }
            this.saveLoading = true
            this.$http.post(`/front/aimj/user/cate/`, this.form).then(res => {
                this.$message.success(this.form.id > 0 ? '编辑成功' : '添加成功')
                this.form.id = 0
                if(this.g_is_cj){
                    // 采集
                    this.is_edit = false
                    this.is_cj = true
                    this.get_hj_list()
                }else{
                    this.close()
                }
            }).finally(() => {
                this.saveLoading = false
            })
        },
        //获取画夹列表
        get_hj_list () {
            this.$http.get(`/front/aimj/user/cate/?soft=mjdraw&max_mj_id=0`).then(res => {
                res.data.item_list.forEach(e => {
                    e.active = false
                });
                this.my_hj_list = res.data.item_list

            }).finally(() => {

            })
        },
        //选中画夹
        choose_hj (item) {
            this.my_hj_list.forEach(e => {
                e.active = false
            })
            item.active = true
        },
        //新建画夹
        create_hj () {
            this.is_edit = true
            this.is_cj = false
        },
        //移动到此
        move () {
            let _arr = []
            this.my_hj_list.forEach(e => {
                if (e.active) {
                    _arr.push(e.id)
                }
            })
            if (!_arr.length) {
                this.$message.error('请选择画夹')
                return
            }
            //发送请求,接口成功后执行一下
            let _id = _arr[0]
            this.$http.patch(`/front/aimj/user/draw/${this.current_draw.draw_id}/`,{action:'addCate', data:{cate_id:_id}}).then(res => {
                this.$message.success('采集成功！')
                this.current_draw.cate_id = _id
                this.close_cj()
            })
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.hj_popup {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
}
.centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
}
.con {
    max-width: 90vw;
    width: 688px;
    padding: 18px;
    background-color: #1e1f22;
    border-radius: 5px;
    .full {
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
        .alert_title {
            margin-bottom: 20px;
            p {
                font-size: 16px;
                color: #fff;
            }
            .close {
                width: 28px;
                height: 28px;
                padding: 6px;
                cursor: pointer;
            }
        }
        .alert_info {
            height: 100%;
            .thumb {
                width: 320px;
                height: 100%;
                justify-content: center;
                flex-direction: column;
                background: #33353a;
                border-radius: 10px;
                .upload_area {
                    background: #414349;
                    flex-direction: column;
                    width: 320px;
                    padding: 50px 0;
                    cursor: pointer;
                    img {
                        margin-bottom: 5px;
                    }
                    p {
                        margin-bottom: 40px;
                    }
                    span {
                        font-size: 12px;
                        color: #fff;
                        padding: 4px 15px;
                        background: rgba(0, 0, 0, 0.6);
                        border-radius: 10px;
                        cursor: pointer;
                    }
                }
                .thumb_area {
                    width: 100%;
                    cursor: pointer;
                    position: relative;
                    padding: 50px 0;
                    img {
                        width: 100%;
                        height: 248px;
                    }
                    span {
                        position: absolute;
                        left: 50%;
                        bottom: 100px;
                        transform: translateX(-50%);
                        font-size: 12px;
                        color: #fff;
                        padding: 4px 15px;
                        background: rgba(0, 0, 0, 0.6);
                        border-radius: 10px;
                        cursor: pointer;
                    }
                }
            }
            .input_area {
                flex: 1;
                .item {
                    margin-bottom: 20px;
                    .input_title {
                        font-size: 12px;
                        color: #9f9f9f;
                        margin-bottom: 5px;
                    }

                    .input {
                        border: 1px solid #5e5386;
                        padding: 7px;
                        border-radius: 10px;
                        .count {
                            position: absolute;
                            top: 50%;
                            right: 10px;
                            transform: translateY(-50%);
                            font-size: 14px;
                        }
                        position: relative;
                        .input_text {
                            background: transparent;
                            width: 100%;
                            border: 0;
                            line-height: 30px;
                            color: rgba(255, 255, 255, 0.78);
                            font-size: 14px;
                        }
                    }
                    &:hover {
                        .input {
                            border-color: #693fff;
                        }
                    }
                    .submit {
                        width: 100%;
                        border-radius: 10px;
                        border: none;
                        line-height: 44px;
                        background-color: #693fff;
                        font-size: 14px;
                        color: #fff;
                        &.gary {
                            background-color: #414349;
                        }
                        /deep/.el-loading-mask {
                            background: none;
                        }
                    }
                }
            }
        }
    }
}
.con1 {
    width: 398px;
    max-width: 90vw;
    padding: 32px 26px;
    background-color: #1e1f22;
    border-radius: 20px;
    .title {
        p {
            font-size: 16px;
            color: #fff;
        }
        img {
            cursor: pointer;
            width: 16px;
            height: 16px;
            &:hover {
                opacity: 0.6;
            }
        }
    }
    .my_hj_list {
        height: 344px;
        border: 1px solid #5b576c;
        border-radius: 10px;
        margin: 20px 0 25px;
        overflow-y: auto;
        .my_hj_item {
            height: 43px;
            padding: 0 12px;
            cursor: pointer;
            border-bottom: 1px solid #5b576c;
            img {
                width: 20px;
                height: 20px;
                margin-right: 5px;
            }
            p {
                font-size: 14px;
                color: #fff;
            }
            &:hover,
            &.active {
                background: rgba(85, 51, 206, 0.27);
            }
        }
    }
    .btn {
        .flex {
            width: 120px;
            height: 44px;
            line-height: 44px;
            border: 1px solid #5b576c;
            border-radius: 10px;
            cursor: pointer;
            span {
                font-size: 14px;
                color: #fff;
            }
            img {
                transform: rotate(45deg);
                width: 14px;
                height: 14px;
                margin-right: 5px;
            }
            &.active {
                background: #693fff;
                border-color: #693fff;
            }
        }
    }
}
</style>